export const ROLES = {
  MEMBER: "member",
  COMPANY_ADMIN: "company_admin",
  SUPER_ADMIN: "super_admin",
};

/**
 * The single client-side source of role truth. Replaces the hardcoded ADMIN_USER_ID
 * that used to live in JobsRail and DrawerComponent.
 *
 * This is UX only — it decides what to *render*. It is not security: the value comes
 * from localStorage and anyone can edit it. Enforcement is @require_role on the server,
 * which is what actually stops a forged role from returning data.
 */
export const useRole = () => {
  const role = localStorage.getItem("role") || ROLES.MEMBER;

  return {
    role,
    isSuperAdmin: role === ROLES.SUPER_ADMIN,
    isCompanyAdmin: role === ROLES.COMPANY_ADMIN || role === ROLES.SUPER_ADMIN,
  };
};

export default useRole;
